var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.isSquare)?_c('div',{staticClass:"ma-auto",style:({ maxWidth: '250px' })},[_c('BtnLayout',{attrs:{"item":_vm.item}})],1):_c('BtnLayout',{attrs:{"item":_vm.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }